import AppConstants from '@/appConstants';

class UpdateDomHelperHelper {
    updateTheme(val) {
        // Update DOM for dark-layout
        if (val === AppConstants.THEME_DARK) document.body.classList.add('dark-layout')
        else if (document.body.className.match('dark-layout')) document.body.classList.remove('dark-layout')
    }

    updateZoom(val) {
        if (val) {
            document.body.style.zoom = val
        }
        // document.body.style.scale = "200%"
    }
}

export default new UpdateDomHelperHelper();